import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Link, FolderOpen, FileText } from 'lucide-react';
import styles from './TabBar.module.css';

export const TabBar = () => {
  const { t } = useTranslation();
  return (
    <nav className={styles.tabBar}>
      <NavLink
        to="/"
        end
        className={({ isActive }) => (isActive ? styles.active : styles.tab)}
      >
        <Link size={20} />
        <span>{t('tabs.links', 'Links')}</span>
      </NavLink>
      <NavLink
        to="/groups"
        className={({ isActive }) => (isActive ? styles.active : styles.tab)}
      >
        <FolderOpen size={20} />
        <span>{t('tabs.groups', 'Groups')}</span>
      </NavLink>
      <NavLink
        to="/files"
        className={({ isActive }) => (isActive ? styles.active : styles.tab)}
      >
        <FileText size={20} />
        <span>{t('tabs.files', 'Files')}</span>
      </NavLink>
    </nav>
  );
};
